var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8BEC5C",
  d: "M0 8.242 5.715 14 16 3.635 14.389 2l-8.674 8.74L1.61 6.619z"
})));
export { SvgFormSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8cGF0aCBpZD0iQ2hlY2siIGQ9Ik0wIDguMjQxNjNMNS43MTQ1NiAxNEwxNiAzLjYzNTA3TDE0LjM4ODkgMkw1LjcxNDU2IDEwLjc0MDlMMS42MTEwNiA2LjYxODIzTDAgOC4yNDE2M1oiIGZpbGw9IiM4QkVDNUMiLz4KPC9nPgo8L3N2Zz4K";